function resolveTicketLegPnrFromList(list) {
  if (!Array.isArray(list)) return '';
  for (let i = list.length - 1; i >= 0; i -= 1) {
    const pnr = String(list[i]?.pnr || '').trim();
    if (pnr) return pnr;
  }
  return '';
}

/** Departure / return PNR from booking ticket_files (same rules as CSV export). */
export function resolveTicketPnrs(booking) {
  const raw = booking?.ticketFiles ?? booking?.ticket_files;
  const base = raw && typeof raw === 'object' ? raw : {};
  const dpnr = String(
    base.departurePnr ?? base.departure_pnr ?? resolveTicketLegPnrFromList(base.departure)
  ).trim();
  const rpnr = String(
    base.returnPnr ?? base.return_pnr ?? resolveTicketLegPnrFromList(base.return)
  ).trim();
  return { dpnr, rpnr };
}

/** Get latest upload timestamp ISO string from departure and return ticket files. */
export function resolveLatestTicketUploadDate(booking) {
  const raw = booking?.ticketFiles ?? booking?.ticket_files;
  const base = raw && typeof raw === 'object' ? raw : {};
  const allFiles = [
    ...(Array.isArray(base.departure) ? base.departure : []),
    ...(Array.isArray(base.return) ? base.return : [])
  ];
  let latest = null;
  let latestMs = 0;
  for (const f of allFiles) {
    const rawDate = f?.uploadedAt || f?.uploaded_at || f?.createdAt || f?.created_at;
    if (rawDate) {
      const ms = new Date(rawDate).getTime();
      if (!isNaN(ms) && ms > latestMs) {
        latestMs = ms;
        latest = rawDate;
      }
    }
  }
  return latest;
}
